import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11c67bf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-checkout" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "d-none d-md-block step-container" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Back to cart ")
const _hoisted_5 = { class: "main" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 col-md-7" }
const _hoisted_8 = { class: "col-12 col-md-5" }

import { ref } from 'vue';
  import { CheckoutStore } from '@/stores';
  import Step from './components/step.vue';
  import Total from './components/total.vue';
  import StepShipping from './components/step-shipping.vue';
  import StepPayment from './components/step-payment.vue';
  import StepConfirm from './components/step-confirm.vue';

  interface IProps {
    store: CheckoutStore
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    store: null
  },
  setup(__props: any) {

  
  const steps = ['Shipping', 'Payment', 'Confirm', 'Complete'];
  const stepActive = ref(0);

  function nextStep() {
    stepActive.value++;
  }


return (_ctx: any,_cache: any) => {
  const _component_AppBack = _resolveComponent("AppBack")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Step, {
          modelValue: stepActive.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((stepActive).value = $event)),
          steps: steps
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_AppBack, { to: { name: 'shop.shopping_cart' } }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (stepActive.value === 0)
              ? (_openBlock(), _createBlock(StepShipping, {
                  key: 0,
                  store: __props.store,
                  onSubmit: nextStep
                }, null, 8, ["store"]))
              : _createCommentVNode("", true),
            (stepActive.value === 1)
              ? (_openBlock(), _createBlock(StepPayment, {
                  key: 1,
                  store: __props.store
                }, null, 8, ["store"]))
              : _createCommentVNode("", true),
            (stepActive.value === 2)
              ? (_openBlock(), _createBlock(StepConfirm, {
                  key: 2,
                  store: __props.store
                }, null, 8, ["store"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(Total, { store: __props.store }, null, 8, ["store"])
          ])
        ])
      ])
    ])
  ]))
}
}

})